/* clone-taurine-pdp.js — behaviour for the Taurine product page clone:
   header drawer, gallery, bundle tiers, gifts, subscribe toggle, delivery date,
   add to cart, quote rotator, results rings, sticky bar and back-to-top. */
(function () {
  'use strict';
  // Several sections include this file; run it once.
  if (window.__ctpLoaded) return;
  window.__ctpLoaded = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var LANG = document.documentElement.lang || 'en';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function refreshCartCount() {
    fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-ctp-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count < 1;
        });
      })
      .catch(function () {});
  }

  /* ---------------- header ---------------- */
  function initHeader(header) {
    if (header.dataset.ctpInit) return;
    header.dataset.ctpInit = '1';
    var drawer = $('[data-ctp-drawer]', header);
    function setDrawer(open) {
      if (!drawer) return;
      drawer.classList.toggle('is-open', open);
      document.documentElement.style.overflow = open ? 'hidden' : '';
    }
    $$('[data-ctp-drawer-open]', header).forEach(function (b) { b.addEventListener('click', function () { setDrawer(true); }); });
    $$('[data-ctp-drawer-close]', header).forEach(function (b) { b.addEventListener('click', function () { setDrawer(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setDrawer(false); });
    var dds = $$('.ctp-header__dd', header);
    document.addEventListener('click', function (e) {
      dds.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; });
    });
  }

  /* ---------------- main product ---------------- */
  function initMain(root) {
    if (root.dataset.ctpInit) return;
    root.dataset.ctpInit = '1';
    var cfgEl = $('[data-ctp-config]', root);
    if (!cfgEl) return;
    var cfg = JSON.parse(cfgEl.textContent);
    var variants = cfg.variants || [];
    var byId = {};
    variants.forEach(function (v) { byId[v.id] = v; });

    /* gallery */
    var track = $('[data-ctp-track]', root);
    var slides = track ? $$('.ctp-media__slide', track) : [];
    var thumbs = $$('[data-ctp-thumb]', root);
    var thumbList = $('[data-ctp-thumbs]', root);
    function markThumb(i) {
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', String(n === i)); });
      var t = thumbs[i];
      if (t && thumbList) {
        var l = t.offsetLeft - thumbList.offsetLeft, r = l + t.offsetWidth;
        if (l < thumbList.scrollLeft || r > thumbList.scrollLeft + thumbList.clientWidth) thumbList.scrollLeft = l - 2;
      }
    }
    function goTo(i) {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      markThumb(i);
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          markThumb(Math.min(slides.length - 1, Math.max(0, i)));
        });
      }, { passive: true });
    }
    // Sticky gallery: 30px from the top, or, when it is taller than the space left above the
    // sticky bar, pinned so its bottom (the thumbnails) stays in view, as on the reference.
    var media = $('.ctp-media', root);
    function placeMedia() {
      if (!media) return;
      var room = window.innerHeight - media.offsetHeight - 132;
      media.style.setProperty('--ctp-media-top', Math.min(30, room) + 'px');
    }
    placeMedia();
    window.addEventListener('resize', placeMedia);
    window.addEventListener('load', placeMedia);
    var prev = $('[data-ctp-thumb-prev]', root), next = $('[data-ctp-thumb-next]', root);
    function syncArrows() {
      if (!thumbList || !prev || !next) return;
      prev.disabled = thumbList.scrollLeft <= 2;
      next.disabled = thumbList.scrollLeft + thumbList.clientWidth >= thumbList.scrollWidth - 2;
    }
    if (thumbList) {
      thumbList.addEventListener('scroll', syncArrows, { passive: true });
      if (prev) prev.addEventListener('click', function () { thumbList.scrollBy({ left: -thumbList.clientWidth, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { thumbList.scrollBy({ left: thumbList.clientWidth, behavior: 'smooth' }); });
      syncArrows();
    }

    /* tiers + gifts */
    var idInput = $('[data-ctp-id]', root);
    var atc = $('[data-ctp-atc]', root);
    var tiers = $$('[data-ctp-tier]', root);
    var gifts = $$('[data-ctp-gift]', root);
    var state = { units: 1, variant: idInput ? byId[idInput.value] : null };

    function paintAtc() {
      var v = state.variant;
      if (!atc) return;
      var ok = !!(v && v.available);
      atc.disabled = !ok;
      atc.textContent = ok ? cfg.atcLabel : cfg.soldOutLabel;
      document.dispatchEvent(new CustomEvent('ctp:variant', { detail: { available: ok, variant: v } }));
    }
    function paintGifts() {
      gifts.forEach(function (g) {
        var need = parseInt(g.dataset.unlock, 10) || 0;
        g.classList.toggle('is-locked', state.units < need);
      });
    }
    var stock = $('[data-ctp-stock]', root);
    function paintStock(t) {
      if (!stock) return;
      var n = t.dataset.stock;
      if (n) $('[data-ctp-stock-text]', stock).textContent = stock.dataset.template.replace('[count]', n);
      stock.hidden = !n && !stock.dataset.design;
    }
    function selectTier(t, fromUser) {
      tiers.forEach(function (x) { x.setAttribute('aria-checked', String(x === t)); });
      var v = byId[t.dataset.variant];
      state.units = parseInt(t.dataset.units, 10) || 1;
      state.variant = v || null;
      if (v && idInput) idInput.value = v.id;
      paintStock(t);
      paintGifts();
      paintAtc();
      paintOpts();
      if (fromUser && v) {
        if (v.featured_media && slides.length) {
          var idx = slides.findIndex(function (s) { return s.dataset.mediaId === String(v.featured_media.id); });
          if (idx > -1) goTo(idx);
        }
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {}
      }
    }
    tiers.forEach(function (t) {
      t.addEventListener('click', function () { selectTier(t, true); });
      t.addEventListener('keydown', function (e) {
        var i = tiers.indexOf(t), n = null;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = tiers[(i + 1) % tiers.length];
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = tiers[(i - 1 + tiers.length) % tiers.length];
        if (n) { e.preventDefault(); n.focus(); selectTier(n, true); }
      });
    });
    /* Products with several options: the tiers pick one option (e.g. Pack) and the buttons
       under them pick the rest (e.g. Size, Colour). Each tier's variant follows the buttons. */
    var tierPos = cfg.tierOption || 0;
    var tierPrices = cfg.tierPrices || {};
    var optGroups = tierPos ? $$('[data-ctp-opt]', root) : [];
    var picked = {};
    if (tierPos && state.variant) state.variant.options.forEach(function (val, i) { picked[i + 1] = val; });
    function matches(v, skip) {
      for (var p = 1; p <= v.options.length; p++) {
        if (p === tierPos || p === skip || picked[p] === undefined) continue;
        if (v.options[p - 1] !== picked[p]) return false;
      }
      return true;
    }
    function checkedTier() { return tiers.filter(function (t) { return t.getAttribute('aria-checked') === 'true'; })[0] || tiers[0]; }
    function resolveTiers() {
      if (!tierPos) return;
      tiers.forEach(function (t) {
        var v = variants.filter(function (x) { return x.options[tierPos - 1] === t.dataset.tierValue && matches(x); })[0] || null;
        t.dataset.variant = v ? v.id : '';
        var n = '';
        if (v && v.inventory_management === 'shopify' && v.inventory_quantity > 0 && v.inventory_quantity <= (cfg.stockThreshold || 0)) n = String(v.inventory_quantity);
        t.dataset.stock = n;
        var pr = v && tierPrices[v.id];
        if (pr) {
          var el = $('[data-ctp-tier-total]', t); if (el) el.textContent = pr[0];
          el = $('[data-ctp-tier-each]', t); if (el) el.textContent = pr[1];
          el = $('[data-ctp-tier-was]', t); if (el) { el.textContent = pr[2]; el.hidden = !pr[2]; }
          el = $('[data-ctp-tier-save]', t); if (el) { el.textContent = el.dataset.template.replace('[percent]', pr[3]); el.hidden = !(pr[3] > 0); }
        }
        var img = $('.ctp-tier__img img', t);
        var fi = v && v.featured_image;
        if (img && fi && !t.hasAttribute('data-fixed-img')) {
          var src = fi.src || fi;
          img.removeAttribute('srcset');
          img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
        }
        t.classList.toggle('is-unavailable', !(v && v.available));
      });
    }
    function paintOpts() {
      if (!optGroups.length) return;
      var tv = (checkedTier() || {}).dataset;
      tv = tv ? tv.tierValue : null;
      optGroups.forEach(function (g) {
        var pos = parseInt(g.dataset.ctpOpt, 10);
        $$('.ctp-opt__btn', g).forEach(function (b) {
          var ok = variants.some(function (v) {
            return v.available && v.options[pos - 1] === b.dataset.value && (tv == null || v.options[tierPos - 1] === tv) && matches(v, pos);
          });
          b.classList.toggle('is-unavailable', !ok);
        });
      });
    }
    optGroups.forEach(function (g) {
      var pos = parseInt(g.dataset.ctpOpt, 10);
      var label = $('[data-ctp-opt-value]', g);
      var btns = $$('.ctp-opt__btn', g);
      function pick(b, fromUser) {
        picked[pos] = b.dataset.value;
        btns.forEach(function (x) { x.setAttribute('aria-checked', String(x === b)); });
        if (label) label.textContent = b.dataset.value;
        resolveTiers();
        var cur = checkedTier();
        if (cur) selectTier(cur, fromUser);
      }
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () { pick(b, true); });
        b.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = btns[(i + 1) % btns.length];
          if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = btns[(i - 1 + btns.length) % btns.length];
          if (n) { e.preventDefault(); n.focus(); pick(n, true); }
        });
      });
    });
    resolveTiers();

    var initial = checkedTier();
    if (initial) selectTier(initial, false); else paintAtc();

    /* subscribe */
    var sub = $('[data-ctp-sub]', root);
    var planInput = $('[data-ctp-plan]', root);
    if (sub && planInput) {
      sub.addEventListener('click', function () {
        var on = sub.getAttribute('aria-checked') !== 'true';
        sub.setAttribute('aria-checked', String(on));
        planInput.disabled = !on;
      });
    }

    /* delivery estimate */
    var del = $('[data-ctp-delivery]', root);
    if (del) {
      var d = new Date(), left = cfg.shipDays || 0;
      while (left > 0) {
        d.setDate(d.getDate() + 1);
        var w = d.getDay();
        if (w !== 0 && w !== 6) left--;
      }
      var day = d.getDate(), label;
      if (/^en/i.test(LANG)) {
        var sfx = (day % 10 === 1 && day !== 11) ? 'st' : (day % 10 === 2 && day !== 12) ? 'nd' : (day % 10 === 3 && day !== 13) ? 'rd' : 'th';
        label = d.toLocaleDateString(LANG, { month: 'long' }) + ' ' + day + sfx;
      } else {
        label = d.toLocaleDateString(LANG, { month: 'long', day: 'numeric' });
      }
      $('[data-ctp-delivery-date]', del).textContent = label;
      del.hidden = false;
    }

    /* add to cart */
    var form = $('[data-ctp-form]', root);
    var err = $('[data-ctp-error]', root);
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!state.variant || !state.variant.available) return;
        var item = { id: state.variant.id, quantity: 1 };
        if (planInput && !planInput.disabled && planInput.value) item.selling_plan = +planInput.value;
        var items = [item];
        gifts.forEach(function (g) {
          if (!g.classList.contains('is-locked') && g.dataset.giftVariant) {
            items.push({ id: +g.dataset.giftVariant, quantity: 1, properties: { _gift: 'Free gift' } });
          }
        });
        if (err) err.hidden = true;
        atc.disabled = true;
        fetch(ROOT + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('ctp:added'));
            if (cfg.afterAdd === 'stay') {
              refreshCartCount();
              paintAtc();
            } else {
              window.location.href = ROOT + 'cart';
            }
          })
          .catch(function (x) {
            if (err) { err.textContent = x.message; err.hidden = false; }
            paintAtc();
          });
      });
    }
    window.CTP = window.CTP || {};
    window.CTP.addToCart = function () {
      if (form) { if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true })); }
    };
    window.CTP.atc = atc;
    window.CTP.state = state;

    /* quote rotator */
    var quotes = $$('.ctp-quote', root);
    var dots = $$('[data-ctp-dot]', root);
    if (quotes.length > 1) {
      var qi = 0, timer;
      var show = function (i) {
        qi = i;
        quotes.forEach(function (q, n) { q.classList.toggle('is-active', n === i); });
        dots.forEach(function (b, n) { b.setAttribute('aria-current', String(n === i)); });
      };
      var start = function () { clearInterval(timer); timer = setInterval(function () { show((qi + 1) % quotes.length); }, 5000); };
      dots.forEach(function (b, n) { b.addEventListener('click', function () { show(n); start(); }); });
      start();
    }
  }

  /* ---------------- results rings ---------------- */
  function initRings(section) {
    if (section.dataset.ctpInit) return;
    section.dataset.ctpInit = '1';
    var arcs = $$('.ctp-stat__arc', section);
    if (!arcs.length || !('IntersectionObserver' in window)) return;
    arcs.forEach(function (a) {
      a.dataset.final = a.style.strokeDashoffset;
      a.style.transition = 'none';
      a.style.strokeDashoffset = a.getAttribute('stroke-dasharray');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        arcs.forEach(function (a) { a.style.transition = ''; a.style.strokeDashoffset = a.dataset.final; });
        io.disconnect();
      });
    }, { threshold: 0.3 });
    requestAnimationFrame(function () { io.observe(section); });
  }

  /* ---------------- sticky bar + back to top ---------------- */
  function initSticky(bar) {
    if (bar.dataset.ctpInit) return;
    bar.dataset.ctpInit = '1';
    var btn = $('[data-ctp-sticky-btn]', bar);
    var totop = $('[data-ctp-totop]');
    var target = (window.CTP && window.CTP.atc) || $('[data-ctp-atc]');
    var pricesEl = $('[data-ctp-sticky-prices]', bar);
    var prices = {};
    try { if (pricesEl) prices = JSON.parse(pricesEl.textContent); } catch (e) {}
    var priceEl = $('[data-ctp-sticky-price]', bar), compareEl = $('[data-ctp-sticky-compare]', bar);
    var saveEl = $('[data-ctp-sticky-save]', bar);
    function paint(v, available) {
      if (btn) btn.disabled = !available;
      var p = v && prices[v.id];
      if (!p || !priceEl) return;
      priceEl.textContent = p[0];
      if (compareEl) compareEl.textContent = p[1];
      if (saveEl) {
        saveEl.hidden = !p[2];
        saveEl.lastElementChild.textContent = saveEl.dataset.template.replace('[percent]', p[2]);
      }
    }
    var handle = $('[data-ctp-sticky-handle]', bar);
    if (handle) handle.addEventListener('click', function () {
      var collapsed = bar.classList.toggle('is-collapsed');
      handle.setAttribute('aria-expanded', String(!collapsed));
    });
    if (btn) {
      btn.addEventListener('click', function () {
        if (window.CTP && window.CTP.addToCart) window.CTP.addToCart();
        else if (btn.dataset.url) window.location.href = btn.dataset.url;
      });
    }
    document.addEventListener('ctp:variant', function (e) { paint(e.detail.variant, e.detail.available); });
    // The buy box picks its default pack before this bar exists, so read its current state once.
    var st = window.CTP && window.CTP.state;
    if (st) paint(st.variant, !!(st.variant && st.variant.available)); else if (target && btn) btn.disabled = target.disabled;
    // Scroll position rather than IntersectionObserver, so jumps past the button still register.
    var ticking = false;
    function onScroll() {
      ticking = false;
      bar.classList.toggle('is-visible', target ? target.getBoundingClientRect().bottom < 0 : window.scrollY > 600);
      if (totop) totop.classList.toggle('is-visible', window.scrollY > 600);
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
    onScroll();
    if (totop) totop.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: 'smooth' }); });
  }

  function boot() {
    $$('[data-ctp-header]').forEach(initHeader);
    $$('[data-ctp-main]').forEach(initMain);
    $$('[data-ctp-results]').forEach(initRings);
    $$('[data-ctp-sticky]').forEach(initSticky);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
